import { isDesktopLayout } from "../../../common/hooks/useIsDesktopView";

/**
 * Which room pages the reader gets: the desktop room shell (directory, room
 * page, Follow and its welcome) on the desktop layout, the phone's pages
 * elsewhere. The desktop layout only exists inside the desktop shell, where
 * the shell's dialogs (the room welcome) mount.
 */
export type RoomsLayout = "mobile" | "desktop";

export function useRoomsLayout(): RoomsLayout {
  return isDesktopLayout() ? "desktop" : "mobile";
}
